const statusTranslations = {
  "pending for restaurant confirmation":
    "pendiente por confirmación del restaurante",
};

export default statusTranslations;
